import toto from "modules/toto";
(function (global) {

    const initSkeletons = () => {
        document
        .querySelectorAll("figure")
        .forEach((container) => {
            const img = container.querySelector("img");
            const markLoaded = () => container.classList.add("is-loaded");
            if (!img) {
                markLoaded();
                return;
            }
            if (img.complete) {
                img.classList.add("img-is-loaded");
                markLoaded();
                return;
            }
            container.classList.add("skel-media");
            img.addEventListener("load", markLoaded, { once: true });
            img.addEventListener("error", markLoaded, { once: true });
            setTimeout(markLoaded, 2500);
        });
    };
    const afterHeroPaint = (fn) => {
        requestAnimationFrame(() => requestAnimationFrame(fn));
    };

    const findEquipeControl = (track, selector) => {
        let node = track.parentElement;
        while (node) {
            const match = Array.from(node.querySelectorAll(selector)).find(
                (el) => !track.contains(el)
            );
            if (match) {
                return match;
            }
            node = node.parentElement;
        }
        return null;
    };

    const setEquipeControlState = (el, disabled) => {
        if (!el) {
            return;
        }
        el.classList.toggle("is-disabled", disabled);
        el.setAttribute("aria-disabled", disabled ? "true" : "false");
        const link = el.matches("a") ? el : el.querySelector("a");
        if (link) {
            link.setAttribute("tabindex", disabled ? "-1" : "0");
            link.setAttribute("aria-disabled", disabled ? "true" : "false");
        }
    };

    const initEquipeCarousels = () => {
        const prefersReducedMotion = window.matchMedia(
            "(prefers-reduced-motion: reduce)"
        ).matches;

        document
            .querySelectorAll(".carousel-type-equipe")
            .forEach((track, index) => {
                const slides = track.querySelectorAll(".type-equipe");
                if (!slides.length) {
                    return;
                }

                const prev = findEquipeControl(track, ".equipe-left");
                const next = findEquipeControl(track, ".equipe-right");
                if (!prev && !next) {
                    return;
                }

                if (!track.id) {
                    track.id = `equipe-carousel-${index}`;
                }
                track.setAttribute("role", "region");
                track.setAttribute("aria-roledescription", "carousel");
                if (!track.getAttribute("aria-label")) {
                    track.setAttribute("aria-label", "Carousel de l'équipe");
                }

                const getStep = () => {
                    if (slides.length < 2) {
                        return slides[0].getBoundingClientRect().width;
                    }
                    return slides[1].offsetLeft - slides[0].offsetLeft;
                };

                const updateControls = () => {
                    const max = Math.max(
                        0,
                        track.scrollWidth - track.clientWidth
                    );
                    setEquipeControlState(prev, track.scrollLeft <= 1);
                    setEquipeControlState(next, track.scrollLeft >= max - 1);
                };

                const scrollByDir = (dir) => {
                    track.scrollBy({
                        left: dir * getStep(),
                        behavior: prefersReducedMotion ? "auto" : "smooth",
                    });
                };

                const onPrev = (event) => {
                    event.preventDefault();
                    if (prev?.classList.contains("is-disabled")) {
                        return;
                    }
                    scrollByDir(-1);
                };

                const onNext = (event) => {
                    event.preventDefault();
                    if (next?.classList.contains("is-disabled")) {
                        return;
                    }
                    scrollByDir(1);
                };

                const bindControl = (el, handler, label) => {
                    if (!el) {
                        return;
                    }
                    el.setAttribute("aria-controls", track.id);
                    const link = el.matches("a") ? el : el.querySelector("a");
                    if (link && !link.getAttribute("aria-label")) {
                        link.setAttribute("aria-label", label);
                    }
                    if (link && !link.getAttribute("href")) {
                        link.setAttribute("href", "#");
                    }
                    el.addEventListener("click", handler);
                };

                bindControl(prev, onPrev, "Membres précédents");
                bindControl(next, onNext, "Membres suivants");
                track.addEventListener("scroll", updateControls, {
                    passive: true,
                });

                if (typeof ResizeObserver !== "undefined") {
                    new ResizeObserver(updateControls).observe(track);
                } else {
                    window.addEventListener("resize", updateControls);
                }

                updateControls();
            });
    };

    const bootRest = () => {
        initEquipeCarousels();
        initSkeletons();
        // initLenis();
        // initReveals(gsap, ScrollTrigger, defaultEnergy);
        // const refresh = () => ScrollTrigger.refresh();
        window.addEventListener("load", ()=>{}, { once: true });
        // setTimeout(refresh, 400);
    };

    afterHeroPaint(() => {
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", bootRest, {
                once: true,
            });
            return;
        }
        bootRest();
    });
})(window);